exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._table-automations{width:100%!important}._table-automations .row-automation{cursor:pointer}._table-automations .row-automation td:first-child{width:100%;white-space:nowrap;display:flex;align-items:center}._table-automations .row-automation td:last-child{width:1%;white-space:nowrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/stylus-loader!./src/components/plain/tableAutomations/tableAutomations.styl
// module id = 445
// module chunks = 0